(() => {
  if (window.TechnogoldStockOrder) return;
  const selector = '[data-stock-order]';
  const cards = (grid) => Array.from(grid.querySelectorAll(':scope > [data-stock-product]'));

  function segments(available, total, size, page, priorities = []) {
    const pins = [...new Set(priorities)].filter(i => Number.isSafeInteger(i) && i >= 0 && i < available);
    const pinned = new Set(pins);
    const availableOrder = [...pins, ...Array.from({ length: available }, (_, i) => i).filter(i => !pinned.has(i))];
    const result = [];
    for (let index = (page - 1) * size; index < Math.min(page * size, total); index++) {
      const value = index < available ? '1' : '0';
      const sourceIndex = value === '1' ? availableOrder[index] : index - available;
      const sourcePage = Math.floor(sourceIndex / size) + 1;
      const offset = sourceIndex % size;
      const previous = result[result.length - 1];
      if (previous && previous.value === value && previous.page === sourcePage && previous.offset + previous.length === offset) previous.length++;
      else result.push({ value, page: sourcePage, offset, length: 1 });
    }
    return result;
  }

  async function priorities(d, address, signal) {
    const url = new URL(address, window.location.origin);
    const customSort = url.searchParams.get('sort_by');
    if (!d.stockCollectionId || [...url.searchParams.keys()].some(key => key.startsWith('filter.')) ||
        (customSort && customSort !== d.stockDefaultSort)) return { positions: [], ids: [] };
    const endpoint = new URL('https://technogold-avisos.ayrtonmarin1205.workers.dev/priority');
    endpoint.searchParams.set('collection', d.stockCollectionId);
    const result = await fetch(endpoint, { signal, credentials: 'omit' });
    if (!result.ok) throw new Error('Priority unavailable');
    const data = await result.json();
    if (!Array.isArray(data.positions) || !Array.isArray(data.ids) || data.positions.length !== data.ids.length ||
        (data.positions.length && data.available_count !== Number(d.stockAvailable))) throw new Error('Stock priority changed');
    return data;
  }

  async function order(root, address) {
    const grid = root.querySelector(selector);
    if (!grid || grid.dataset.stockState === 'ready') return;
    const d = grid.dataset;
    const available = Number(d.stockAvailable);
    const unavailable = Number(d.stockUnavailable);
    const total = Number(d.stockTotal);
    const size = Number(d.stockSize);
    const page = Number(d.stockPage);
    if (d.stockFilterFound !== 'true' || Number(d.stockFilterActive) === 1 ||
        ![available, unavailable, total, size, page].every(Number.isSafeInteger) ||
        size < 1 || page < 1 || available + unavailable !== total || !available) {
      grid.dataset.stockState = 'native';
      return;
    }
    const original = cards(grid);
    const expected = Math.max(0, Math.min(size, total - (page - 1) * size));
    if (!expected || original.length !== expected) return;
    const live = grid.isConnected;
    const currentAddress = window.location.href;
    grid.setAttribute('aria-busy', 'true');
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 20000);
    try {
      let ordered, priority = { positions: [], ids: [] };
      try { priority = await priorities(d, address, controller.signal); }
      catch (error) { console.warn('Technogold restock priority:', error.message); }
      grid.dataset.stockPriority = String(priority.positions.length);
      if (total <= size) {
        ordered = [
          ...original.filter((card) => card.dataset.stockAvailable === 'true').sort((a, b) => {
            const ai = priority.ids.indexOf(a.dataset.stockProduct), bi = priority.ids.indexOf(b.dataset.stockProduct);
            return (ai < 0 ? Infinity : ai) - (bi < 0 ? Infinity : bi);
          }),
          ...original.filter((card) => card.dataset.stockAvailable === 'false'),
        ];
      } else {
        const chunks = await Promise.all(segments(available, total, size, page, priority.positions).map(async (segment) => {
          const url = new URL(address, window.location.origin);
          url.hash = '';
          url.searchParams.delete('sections');
          url.searchParams.set('section_id', d.stockSection);
          url.searchParams.set('filter.v.availability', segment.value);
          url.searchParams.set('page', String(segment.page));
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error('Stock page unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = parsed.querySelector(selector);
          if (!source || Number(source.dataset.stockTotal) !== (segment.value === '1' ? available : unavailable))
            throw new Error('Stock changed while loading');
          const selection = cards(source).slice(segment.offset, segment.offset + segment.length);
          if (selection.length !== segment.length ||
              selection.some((card) => card.dataset.stockAvailable !== (segment.value === '1' ? 'true' : 'false')))
            throw new Error('Incomplete stock page');
          return selection;
        }));
        ordered = chunks.flat();
      }
      if (live && (!grid.isConnected || window.location.href !== currentAddress)) return;
      if (ordered.length !== expected || new Set(ordered.map((card) => card.dataset.stockProduct)).size !== expected)
        throw new Error('Incomplete stock order');
      const replacements = ordered.map((card) => card.cloneNode(true));
      original.forEach((card, index) => card.replaceWith(replacements[index]));
      grid.dataset.stockState = 'ready';
      if (live) {
        const switcher = document.querySelector('layout-switcher');
        const active = switcher?.querySelector('.btn--active');
        if (active) switcher.onButtonClick(active);
        document.dispatchEvent(new CustomEvent('collection:rerendered'));
      }
    } catch (error) {
      grid.dataset.stockState = 'fallback';
      console.warn('Technogold stock order:', error.message);
    } finally {
      window.clearTimeout(timeout);
      grid.removeAttribute('aria-busy');
    }
  }

  async function prepare(html, url) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    await order(parsed, url);
    return parsed.body.innerHTML;
  }

  window.TechnogoldStockOrder = { order, prepare, segments };
  const start = () => order(document, window.location.href);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

